/**
 * Renders the review photo carousel from merchant-added Liquid blocks
 * (sections/product-review-photos.liquid) instead of fetching from Yotpo.
 *
 * The section server-renders both the visible slide markup and, per block,
 * the corresponding modal content inside a <template>. This script only
 * wires up the click-to-open interaction and the two Swiper instances
 * (outer carousel + modal gallery when a review has more than one photo).
 */
(() => {
  const SELECTOR = "[data-product-review-photos]";

  function build(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = "true";

    const wrapper = root.querySelector("[data-product-review-photos-wrapper]");
    if (!wrapper) return;

    const modal = root.dataset.modalId
      ? document.getElementById(root.dataset.modalId)
      : null;
    const modalContent = modal
      ? modal.querySelector("[data-review-modal-content]")
      : null;
    const templatesEl = root.dataset.templatesId
      ? document.getElementById(root.dataset.templatesId)
      : null;

    let modalSwiper = null;

    function openReview(index, opener) {
      if (!modal || !modalContent || !templatesEl) return;

      const source = templatesEl.content.querySelector(
        `[data-review-index="${index}"]`,
      );
      if (!source) return;

      if (modalSwiper) {
        modalSwiper.destroy(true, true);
        modalSwiper = null;
      }

      const content = source.cloneNode(true);
      modalContent.replaceChildren(content);
      modal.show(opener);

      if (content.dataset.swiperInit === "true" && typeof window.Swiper !== "undefined") {
        const swiperContainer = content.querySelector(
          ".product-review-photos-modal__swiper",
        );
        modalSwiper = new window.Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: swiperContainer.querySelector(".swiper-pagination"),
            clickable: true,
          },
          navigation: {
            prevEl: swiperContainer.querySelector(
              ".product-review-photos-modal__nav-btn--prev",
            ),
            nextEl: swiperContainer.querySelector(
              ".product-review-photos-modal__nav-btn--next",
            ),
          },
        });
      }
    }

    const slides = wrapper.querySelectorAll("[data-review-index]");
    if (slides.length === 0) return;

    slides.forEach((slide) => {
      const index = slide.dataset.reviewIndex;
      slide.addEventListener("click", () => openReview(index, slide));
      slide.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        openReview(index, slide);
      });
    });

    root.hidden = false;

    if (typeof window.Swiper === "undefined") return;

    new window.Swiper(root.querySelector(".swiper"), {
      slidesPerView: "auto",
      spaceBetween: 4,
      freeMode: false,
      breakpoints: {
        780: {
          spaceBetween: 12,
        },
      },
    });
  }

  function apply(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(build);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => apply());
  } else {
    apply();
  }

  document.addEventListener("shopify:section:load", (event) =>
    apply(event.target),
  );
})();
